export default theme => ({
  root: {
    padding: theme.spacing(3)
  },
  button: {
    marginRight: theme.spacing(3)
  },
  stopsDownloadButton:{

  },
  emptiesDownloadButton: {
    marginLeft: theme.spacing(1),
  },
  tableRow: {
    height: '51px'
  },
  tableCell: {
    whiteSpace: 'nowrap',
  },
  tableCellInner: {
    display: 'flex',
    alignItems: 'center'
  },
  alignLeft: {
    align: 'left',
  },
  content: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
    border: `1px solid ${theme.palette.border}`
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 250,
  },
  tourMap: {
    minWidth: '100%',
    minHeight: 'calc(-195px + 100vh)',
    border: '1px solid lightgrey',
    borderRadius: '3px'
  },
  buttonRight: {
    marginTop: theme.spacing(1),
  },
  helpWrapper: {
    float: 'right',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
});
